import { Controller } from "stimulus"
import { celebratePoints } from "../services/points_celebration_service"

// Fires the confetti points toast once on connect. Wrap shared/_points_celebration
// in an element carrying data-controller="points-celebration" when the server has
// just recorded a first-time quest completion; the template it clones lives inside
// this element. Server-rendered completions (expense snapshot, payoff plan, safety
// net) use this; the check-in and tracker fire celebratePoints from their own
// controllers because their completion is decided client-side.
export default class extends Controller {
  connect() {
    celebratePoints(this.element)
    // Remove the trigger element (and the <template> it wraps) after firing so a
    // Turbo Drive snapshot cached on navigate-away can't restore it and replay the
    // confetti on a browser Back. The toast was appended to <body>, so it is
    // unaffected. (expense_snapshots/show guards this with a no-cache meta;
    // payoff_plan and safety_net rely on this self-removal.)
    this.element.remove()
  }
}
